import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const CancelApprovalModal: LoadableType<{
	approverData: Array<{
		name: string;
		src?: string;
		email?: string;
		userId?: string;
	}>;
	onCancelApproval: () => void;
	onClose: () => void;
	showProfileCards?: boolean;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CancelApprovalModal" */ '../src/Modals/CancelApprovalModal.tsx'
			)
		).CancelApprovalModal,
});
